import React from "react";
import { useNavigate } from "react-router-dom";
import "./Gallery.css";
import useReveal from "./useReveal";


import g1 from "../images/1.png";
import g2 from "../images/2.jpg";
import g3 from "../images/3.png";
import g4 from "../images/4.png";
import g5 from "../images/5.png";
import g6 from "../images/6.jpg";
import g7 from "../images/7.jpg";
import g8 from "../images/8.jpg";
import g9 from "../images/9.jpg";
import g10 from "../images/10.png";
import g11 from "../images/11.png";
import g12 from "../images/12.jpg";
import g13 from "../images/13.jpg";
import g14 from "../images/14.jpg";
import g15 from "../images/15.png";
import g16 from "../images/16.png";

export default function Gallery() {
  const revealRef = useReveal();
  const navigate = useNavigate();

  const galleryItems = [
    { src: g1, title: "Stardust Tapestry", id: "stardust-tapestry" },
    { src: g2, title: "Ares' Forge", id: "ares-forge" },
    { src: g3, title: "Crimson Bloom", id: "crimson-bloom" },
    { src: g4, title: "Cimmeria", id: "cimmeria" },
    { src: g5, title: "The Ever-Watching Eye", id: "the-ever-watching-eye" },
    { src: g6, title: "Shadow’s Last Stand", id: "shadows-last-stand" },
    { src: g7, title: "The Eclipse Gate", id: "the-eclipse-gate" },
    { src: g8, title: "Tide Trotter", id: "tide-trotter" },
    { src: g9, title: "Enrosadira", id: "enrosadira" },
    { src: g10, title: "Settle", id: "settle" },
    { src: g11, title: "Bakehouse", id: "bakehouse" },
    { src: g12, title: "Leviathan", id: "leviathan" },
    { src: g13, title: "Féth Fíadat", id: "feth-fiadat" },
    { src: g14, title: "Petrichor", id: "petrichor" },
    { src: g15, title: "Maisonette", id: "maisonette" },
    { src: g16, title: "Sinkers and Suds", id: "sinkers-and-suds" },
  ];

  return (
    <section
      className="gallery-section reveal"
      id="gallery"
      ref={revealRef}
    >
      <div className="cosmic-bg"></div>

      <h2 className="gallery-title">Gallery ✧</h2>
      <p className="gallery-sub">Fragments of my dream worlds</p>

      <div className="gallery-grid">
        {galleryItems.map((item, i) => (
          <div
            className="gallery-card"
            key={i}
            onClick={() => navigate(`/projects/${item.id}`)}
          >
            <img
              src={item.src}
              alt={item.title}
              className="gallery-img"
            />
            <div className="gallery-overlay">
              <span className="gallery-name">{item.title}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
